import React from "react";
import { useTranslation } from "react-i18next";
import ThermalReceipt from "../../../../Components/GeneralComponents/ThermalReceipt";

const money = (value) => `${Number(value || 0).toFixed(0)} AFN`;

const MedicineOrderPrint = ({ data }) => {
  const { t } = useTranslation();
  const direction = localStorage.getItem("direction");

  const discount = Number(data?.discount || 0);
  const total = Number(data?.total_price || 0);
  const beforeDiscount = total + discount;

  const tableRows = (data?.items || []).map((item) => {
    const price = Number(item.sell_price ?? item.sell_price_display ?? 0);
    const qty = Number(item.quantity || 0);
    return {
      medicine: item.stock_medicine_display,
      price: money(price),
      quantity: qty,
      subtotal: money(price * qty),
    };
  });

  const totals = [
    { label: t("print.totalAmount"), value: money(beforeDiscount), bold: true },
  ];

  if (discount > 0) {
    totals.push({ label: t("print.discount", "Discount"), value: money(discount) });
    totals.push({ label: t("print.afterDiscount", "After Discount"), value: money(total), color: "#0f766e" });
  }

  return (
    <ThermalReceipt
      direction={direction}
      clinicName={t("print.turkishClinic")}
      phone={`${t("print.phone")}: ${t("print.phoneNumber")}`}
      address={t("print.address")}
      note={t("print.returnPolicyNote")}
      orderLine={{
        label: `${t("pharmacy.order")}:`,
        value: `#${data?.id || "-"} - ${data?.date || ""}`,
      }}
      table={{
        columns: [
          { key: "medicine", label: t("pharmacy.medicine"), align: "left" },
          { key: "price", label: t("pharmacy.pricePerQuantity"), align: "center" },
          { key: "quantity", label: t("pharmacy.quantity"), align: "center" },
          { key: "subtotal", label: t("pharmacy.subtotal"), align: "right" },
        ],
        rows: tableRows,
      }}
      totals={totals}
      footerLines={[t("print.thankYou"), t("print.getWellSoon"), t("print.poweredBy")]}
    />
  );
};

export default MedicineOrderPrint;
